import Margin_Bottom_Style from './Margin_Bottom_Style';

const Select_Component_Style = Margin_Bottom_Style;

module.exports = Select_Component_Style;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/style/Select_Component_Style.js
 **/